GatorSurvey.app.directive("gsRangeQuestion", ['surveyResponseService', GsRangeQuestion]);
function GsRangeQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/RangeQuestionLive.html',
        controller: ['$scope', function ($scope) {
            
            $scope.updateResponseText = function (text) {
                surveyResponseService.updateResponseQuestion($scope.gsModel, text);
            };
            
                surveyResponseService.AddNewQuestion($scope.gsModel,
                    function(reponce) {
                        $scope.gsModel.input = reponce.answer;
                    });
            
        }]
    };
}